import { v4 as uuid } from 'uuid'

export interface TExtraField {
  name: string
  extraId: string
  fieldType: string
  required: boolean
  multiSelect: boolean
  catalogId: string
  active: boolean
  id: string
  dropDownItems: string[]
  unique: boolean
  storeInAppointment: boolean
  displayInGrid: boolean
  uiKey?: string
}

export const createExtraField = (data?: Partial<TExtraField>): TExtraField => ({
  id: '',
  name: '',
  extraId: '',
  fieldType: 'TEXT',
  required: false,
  multiSelect: false,
  catalogId: '',
  active: true,
  unique: false,
  dropDownItems: [],
  storeInAppointment: false,
  displayInGrid: false,
  uiKey: data?.id || uuid(),
  ...data,
})

export const mapExtraField = (data: TObjectAny): TExtraField => createExtraField(data)

export interface TExtraFieldValue {
  fieldID: string
  fieldName: string
  value: any
  resolvedValue?: any
}
